import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { InfoFilled } from '@element-plus/icons-vue';

export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: '确认操作吗？',
  },
},
  emits: ["click"],
  setup(__props, { emit }: { emit: ({
  (event: 'click'): void;
}), expose: any, slots: any, attrs: any }) {




return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createBlock(_component_el_popconfirm, {
    width: "220",
    "confirm-button-text": "确认",
    "cancel-button-text": "取消",
    icon: _unref(InfoFilled),
    "icon-color": "#626AEF",
    title: __props.title,
    onConfirm: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, {
    reference: _withCtx(() => [
      _createVNode(_component_el_button, { type: "text" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["icon", "title"]))
}
}

})